import axios from "axios";
import { API_BASE_URL } from "../constants";

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem(
        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
    )}`,
});

const unwrap = (response) => response.data.data;

/**
 * Positive List endpoints for one GDPR software asset.
 * Successful payloads are the GDPR envelope `response.data.data`.
 */
export default class PositiveListService {
    static instance;

    static getInstance() {
        if (!PositiveListService.instance) {
            PositiveListService.instance = new PositiveListService();
        }

        return PositiveListService.instance;
    }

    async listMeasures(softwareId, params = {}) {
        const response = await axios.get(
            `${API_BASE_URL}/software/${softwareId}/positive-list`,
            {
                params,
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async createMeasure(softwareId, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/software/${softwareId}/positive-list`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async getAnalysisStatus(softwareId) {
        const response = await axios.get(
            `${API_BASE_URL}/software/${softwareId}/positive-list/analysis-status`,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async reanalyze(softwareId) {
        const response = await axios.post(
            `${API_BASE_URL}/software/${softwareId}/positive-list/re-analyze`,
            {},
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async getMeasure(measureId) {
        const response = await axios.get(
            `${API_BASE_URL}/positive-list/${measureId}`,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async updateMeasure(measureId, payload) {
        const response = await axios.patch(
            `${API_BASE_URL}/positive-list/${measureId}`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async deleteMeasure(measureId) {
        const response = await axios.delete(
            `${API_BASE_URL}/positive-list/${measureId}`,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async setUsage(measureId, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/positive-list/${measureId}/usage`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async replaceControls(measureId, payload) {
        const response = await axios.put(
            `${API_BASE_URL}/positive-list/${measureId}/controls`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async addEvidence(measureId, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/positive-list/${measureId}/evidence`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }

    async removeEvidence(measureId, evidenceId) {
        const response = await axios.delete(
            `${API_BASE_URL}/positive-list/${measureId}/evidence/${evidenceId}`,
            {
                headers: authHeaders(),
            }
        );

        return unwrap(response);
    }
}
